var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('h1',[_vm._v("Oups...")]),_c('p',[_vm._v("Une erreur s'est produite. N'hésite pas à réessayer plus tard !")])])}
var staticRenderFns = []

export { render, staticRenderFns }